import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import React, { useEffect, useRef, useState } from "react";
import { regColumnsCsv, options, options1 } from "./content.js";

import RegistrationPresentational from "./registration-presentational.js";
import TypeSelect from "./filter-modal.js";
import { columns } from "./registerColumn.js";
import {
  getAllFullKycList,
  getAllNoKycList,
  getAllPartialKycList,
  getAllRegistrationList,
} from "../utils.js";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { channelOptions } from "../allUserDetail/user-contents.js";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification.js";

// import { useHistory } from "react-router-dom";

const registrations = () => {
  const FULL_KYC = "FullKYC";
  const PARTIAL_KYC = "PartialKYC";
  const NO_KYC = "NoKYC";
  const [kyc, setKyc] = useState("FullKYC");
  const [type, setType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const initialRegChannelState = {
    value: "Direct and Bank Referral",
    label: "Direct and Bank Referral",
  };

  const initialSelectedOption = {
    label: "Full KYC",
    value: "FullKYC",
  };
  const [modalShow, setModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [showError, setShowError] = useState(false);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState([initialSelectedOption]);
  const [selectedOption1, setSelectedOption1] = useState([]);

  const [selectedRegChannelOption, setSelectedRegChannelOption] = useState(
    initialRegChannelState
  );
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef(null);
  const csvLink = useRef();
  const request = {
    page: 1,
    size: 10,
    name: null,
    mobile: null,
    branchId: null,
    emiratesId: null,
    cardSerialNumber: null,
    fromDate: null,
    toDate: null,
    RegistrationType: "FullKYC",
    type: null,
    applicationId: 1,
    channel: selectedRegChannelOption.value,
  };
  const [filterForm, setFilterForm] = useState(request);
  const [allUserList, setAllUserList] = useState([]);

  const [allUserListExcel, setallUserListExcel] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  //useEffect
  useEffect(() => {
    if (kyc === "NoKYC" && searchByValue.length < 3) {
      setShowError(true);
    } else {
      setShowError(false);
    }
    setNoOfFiltersSelected(selectedOption.length + selectedOption1.length + 1); // Added 1 for channel filter by default selected one item at any time and its a single select
    setFiltersSelected(true);
  }, [kyc, showError, selectedOption, searchByValue]);

  useEffect(() => {
    if (filterForm) {
      getRegistrationData(filterForm);
    }
  }, [filterForm]);

  const getApiServiceHandler = (regType) => {
    if (regType === FULL_KYC) {
      return getAllFullKycList;
    } else if (regType === PARTIAL_KYC) {
      return getAllPartialKycList;
    } else if (regType === NO_KYC) {
      return getAllNoKycList;
    } else {
      return getAllRegistrationList;
    }
  };

  //api call
  const getRegistrationData = (request) => {
    request.size = sizeShow || 10;
    let serviceApi = getApiServiceHandler(request.RegistrationType);
    setDataLoading(true);
    serviceApi(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.users.length > 0) {
          //
          setAllUserList(res.data.users);
        }
        // if (res && res.data && res.data.users.length > 0 && eidStatus===true) {
        //   const newlist =res.data.users.filter(list=>list.registrationType==="WithEid")
        //   setAllUserList(newlist);
        // } else  if (res && res.data && res.data.users.length > 0 && eidStatus===false){

        //   const newlist =res.data.users.filter(list=>list.registrationType==="WithoutEid")
        //   setAllUserList(newlist);
        // }
        else {
          setAllUserList([]);
        }

        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        console.log({ err });
        setAllUserList([]);
      });
  };
  //filter
  const handleFIlter = (searchByValue) => {
    let request = {};
    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue.trim(),
        mobile: null,
        branchId: null,
        emiratesId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "mobile") {
      request = {
        ...filterForm,
        mobile: searchByValue.trim(),
        name: null,
        branchId: null,
        emiratesId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "branchId") {
      request = {
        ...filterForm,
        branchId: searchByValue.trim(),
        mobile: null,
        name: null,
        emiratesId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "emiratesId") {
      request = {
        ...filterForm,
        emiratesId: searchByValue.trim(),
        mobile: null,
        name: null,
        branchId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "cardSerialNumber") {
      request = {
        ...filterForm,
        cardSerialNumber: searchByValue.trim(),
        mobile: null,
        name: null,
        branchId: null,
        emiratesId: null,
      };
    } else if (searchBy === "ctid") {
      request = {
        ...filterForm,
        citizenId: searchByValue.trim(),
        mobile: null,
        name: null,
        branchId: null,
        emiratesId: null,
      };
    }
    request.page = 1;
    request.RegistrationType = kyc;
    request.channel = selectedRegChannelOption.value;
    request.type = type;
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;
    request.searchFilter = [];
    if (selectedOption.length > 0) {
      selectedOption.forEach((v) => {
        request.searchFilter.push(v.value);
        // request.withEID = v.value; // TODO -CHECK
      });
    }

    setFilterForm(request);
  };
  // selected options
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([{ ...selectedOption }]);
    }
  };
  const handleChange1 = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption1([{ ...selectedOption }]);
    }
  };
  const handleRegChannelChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedRegChannelOption(selectedOption);
    } else {
      setSelectedRegChannelOption("");
    }
  };
  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length + selectedOption1.length + 1); // Added 1 for channel filter by default selected one item at any time and its a single select
    setModalShow(false);

    setFiltersSelected(true);
    selectedOption.map((option) => {
      switch (option.label) {
        case "Full  KYC":
          setKyc("FullKYC");
          return setFilterValues(!filterValues);
          break;
        case "Partial KYC":
          setKyc("PartialKYC");
          return setFilterValues(!filterValues);
          break;
        case "No KYC":
          setKyc("NoKYC");
          return setFilterValues(!filterValues);
        default:
          return "";
      }
    });
    selectedOption1.map((option) => {
      switch (option.label) {
        case "Passport":
          setType("Passport");
          // setFilterForm({...filterForm,withEID:true})
          return setFilterValues(!filterValues);
          break;
        case "EmiratesId":
          setType("EID");
          // setFilterForm({...filterForm,withEID:true})
          return setFilterValues(!filterValues);
          break;
        case "EID + Passport":
          setType("EID_Passport");

          return setFilterValues(!filterValues);
        default:
          return "";
      }
    });
  };

  const rowOnClick = {
    onClick: (e, row, rowIndex) => {
      rowClicked(row);
    },
  };

  //placeholderss
  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Ahmed";
  } else if (searchBy === "mobile") {
    searchByValuePlaceholder = "971xxxx/05xxx";
  } else if (searchBy === "branchId") {
    searchByValuePlaceholder = "99999";
  } else if (searchBy === "emiratesId") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else if (searchBy === "ctid") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else if (searchBy === "cardSerialNumber") {
    searchByValuePlaceholder = "1234567890";
  } else {
    searchByValuePlaceholder = "971xxxxxxxxx";
  }
  //reset
  const resetFilter = () => {
    setSearchBy("mobile");
    setShowError(false);
    setSearchByValue("");
    setNoOfFiltersSelected(false);
    setFiltersSelected(true);
    setAllUserList([]);
    setallUserListExcel([]);
    setFromDate(null);
    setKyc("FullKYC");
    setType("");
    setToDate(null);
    setSelectedOption([initialSelectedOption]);
    setSelectedOption1([]);
    setFilterValues(false);
    let request = {};
    request.page = 1;
    request.RegistrationType = "FullKYC";
    request.channel = initialRegChannelState.value;
    setFilterForm(request);
    setSelectedRegChannelOption(initialRegChannelState);
  };
  //excel download
  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.channel = selectedRegChannelOption.value;
    request.page = "";
    request.size = "";
    getAllRegistrationList(request)
      .then((res) => {
        if (res && res.data && res.data.users.length > 0) {
          let data = res.data.users.map((element) => {
            if (element.registrationDate) {
              element.registrationDate = moment(
                element.registrationDate
              ).format("DD-MM-YYYY");
            }
            return element;
          });
          setallUserListExcel(data);
          buttonRef.current.click();
        } else {
          openNotificationWithIcon(
            notificationStrings.warning,
            "No Record Found"
          );
          setallUserListExcel([]); //TODO :  NEED TO REMOVE  -ONLY DUMMY DATA
        }
      })
      .catch((err) => {
        console.log({ err });
        setallUserListExcel([]);
      });
  };
  const history = useHistory();

  const rowClicked = (data) => {
    let states = { ...data, title: "Verifications" };
    history.push({
      pathname: "/admin/registration-verification",
      state: states,
    });
  };

  useEffect(() => {
    let checkDuplicate =
      columns &&
      columns.filter((column, index) => {
        return column.dataField === "action";
      });
    console.log(checkDuplicate);
    if (checkDuplicate.length === 0) {
      columns.unshift({
        dataField: "action",
        text: "",
        style: { minWidth: "50px", textAlign: "center" },
        sort: false,
        formatter: (cell, row) => {
          return (
            <>
              <i
                style={{ fontSize: 18 }}
                className="fas fa-search"
                onClick={() => {
                  rowClicked(row);
                }}
              />
            </>
          );
        },
      });
    }
  }, [columns]);

  return (
    <>
      <RegistrationPresentational
        searchBy={searchBy}
        setSearchByValue={setSearchByValue}
        searchByValue={searchByValue}
        setSearchBy={setSearchBy}
        searchByValuePlaceholder={searchByValuePlaceholder}
        fromDate={fromDate}
        rowOnClick={rowOnClick}
        toDate={toDate}
        setToDate={setToDate}
        setModalShow={setModalShow}
        filtersSelected={filtersSelected}
        noOfFiltersSelected={noOfFiltersSelected}
        resetFilter={resetFilter}
        handleFIlter={handleFIlter}
        filterValues={filterValues}
        allUserList={allUserList}
        dataLoading={dataLoading}
        pagination={pagination}
        allUserListExcel={allUserListExcel}
        buttonRef={buttonRef}
        csvLink={csvLink}
        onExcelClciked={onExcelClciked}
        filterForm={filterForm}
        columns={columns}
        columnsCsv={regColumnsCsv}
        setSizeShow={setSizeShow}
        setFilterForm={setFilterForm}
        setFromDate={setFromDate}
        kyc={kyc}
        showError={showError}
        setShowError={setShowError}
      />
      <TypeSelect
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleChange={handleChange}
        options={options}
        selectedOption={selectedOption}
        handleChanged={handleChange1}
        handleRegChannelChange={handleRegChannelChange}
        optionss={options1}
        channelOptions={channelOptions}
        showRegChannelFilter={true}
        selectedOptions={selectedOption1}
        statusFilter={statusFilter}
        selectedRegChannelOption={selectedRegChannelOption}
        setSelectedRegChannelOption={setSelectedRegChannelOption}
      />
    </>
  );
};

export default registrations;
